export default "__VITE_ASSET__BIbopvkQ__"